const config = {
  // 接口服务地址  http://api.usftools.cn
  baseURL:
    process.env.NODE_ENV === 'production'
      ? 'https://api.usftools.cn'
      : 'https://api.usftools.cn',
  // 静态资源地址
  staticURL:
    process.env.NODE_ENV === 'production'
      ? 'https://api.usftools.cn/static'
      : 'https://api.usftools.cn/static'
}
export default config



// WEBPACK FOOTER //
// ./src/api/config.js